<template>
  <div v-if="all && allUsers">
    <v-row>
      <v-col cols="10" offset="1">
         <!-- Loop through all docs-->
          <v-row v-for="(x, index) in all" :key="index">
            <v-col cols="12" class="ma-0">
              <span class="headline ma-0">{{getUser(x.uid)}}</span>
            </v-col>
            <v-col cols="6" v-for="item in x.doc.listNames" :key="item.name">
                <results-pages class="mt-0" :items="x.doc.list[item.name]" :title="item.title"></results-pages>
            </v-col>
          </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import lodash from "lodash";

const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import ResultsPages from "@/components/results/structure/ResultsPages";

export default {
  name: "ResultsStructureSummary",
  data() {
    return {
      items: null,
      admins: null,
      users: null,
      all: null,
      allUsers: null,
      adminCheck: false,
    };
  },
  components: {
    ResultsPages
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getUsers();
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getUsers();
    this.getAdmins();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAdmins() {
      console.log("admins");
      let ref = fb.profilesCollection.where("webrole", "==", "admin");
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post.uid);
          });
          if (items) {
            this.admins = items;
          }
          this.getExercise();
        })
        .catch(function() {});
    },
    getUsers() {
      let ref = fb.profilesCollection;
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.allUsers = items;
          }
        })
        .catch(function() {});
    },
    getExercise() {
      console.log("exercise");
      this.doc = null;
      let ref = fb.structureExCollection.where("pid", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            if (this.adminCheck) {
              if (!this.admins.some((x) => x == post.uid)) {
                items.push(post);
              }
            } else {
              items.push(post);
            }
          });
          if (items) {
            this.all = items;
          }
        })
        .catch(function() {});
    },
    getUser(id) {
      if (this.allUsers) {
        let item = this.allUsers.find(x => x.uid === id);
        return `${item.first}`;
      }
    }
  },
};
</script>

<style lang="scss">
.preview {
  width: 100%;
  height: auto;
}
</style>
